import { Link } from "react-router-dom";
import { HelpCircle, FileText, Coins } from "lucide-react";
import { IMAGES } from "../lib/api";

export const Navbar = ({ credits, onTour, onReports }) => (
  <header data-testid="site-navbar" className="sticky top-0 z-40 border-b border-[#1f1f1f] bg-[#050505]/85 backdrop-blur-xl">
    <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:px-8">
      <Link to="/" data-testid="nav-home-link" className="group flex items-center gap-3">
        <span className="relative h-9 w-9 overflow-hidden border border-red-900/60">
          <img src={IMAGES.heart} alt="" className="h-full w-full scale-150 object-cover transition-transform duration-500 group-hover:scale-[1.7]" />
        </span>
        <span className="leading-none">
          <span className="font-display block text-[15px] font-bold tracking-wide">Unlovable<span className="text-red-500">.Click</span></span>
          <span className="rea-label !text-[9px] !tracking-[0.3em]">featuring <span className="gold-text font-bold">R.E.A.</span></span>
        </span>
      </Link>
      <nav className="flex items-center gap-1 sm:gap-3">
        {[["terms", "Terms"], ["privacy", "Privacy"], ["data", "Data"]].map(([k, l]) => (
          <Link key={k} to={`/legal/${k}`} data-testid={`nav-legal-${k}`} className="hidden px-2 py-2 font-mono text-[11px] uppercase tracking-widest text-neutral-500 transition-colors hover:text-white md:block">{l}</Link>
        ))}
        {credits !== null && credits !== undefined && (
          <span data-testid="nav-credits" className="flex items-center gap-2 border border-[#262626] px-2 py-1.5 font-mono text-xs text-neutral-300 sm:px-3">
            <Coins className="h-3.5 w-3.5 text-[#d4af37]" /> {credits}<span className="hidden sm:inline"> credit{credits === 1 ? "" : "s"}</span>
          </span>
        )}
        {onReports && (
          <button data-testid="nav-my-reports-btn" onClick={onReports} className="flex items-center gap-2 px-3 py-2 font-mono text-xs uppercase tracking-widest text-neutral-400 transition-colors hover:text-white">
            <FileText className="h-4 w-4" /> <span className="hidden sm:inline">My Reports</span>
          </button>
        )}
        {onTour && (
          <button data-testid="nav-take-tour-btn" onClick={onTour} className="flex items-center gap-2 px-3 py-2 font-mono text-xs uppercase tracking-widest text-neutral-400 transition-colors hover:text-red-400">
            <HelpCircle className="h-4 w-4" /> <span className="hidden sm:inline">Help / Take the Tour</span>
          </button>
        )}
      </nav>
    </div>
  </header>
);
